import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const BLUE  = 'var(--signal)';
const TEXT1 = 'var(--ink)';
const TEXT2 = 'var(--slate)';
const TEXT3 = 'var(--mute)';

export default function Welcome() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const rawName = user?.first_name ?? user?.firstName ?? '';
  const firstName = rawName.charAt(0).toUpperCase() + rawName.slice(1);

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: 'var(--paper)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px 16px',
      boxSizing: 'border-box',
    }}>
      <div style={{
        width: '100%',
        maxWidth: 420,
        backgroundColor: 'var(--card)',
        borderRadius: 'var(--r-card)',
        padding: 32,
        boxSizing: 'border-box',
        boxShadow: 'var(--sh-raise)',
      }}>
        <p style={{
          margin: '0 0 32px',
          fontFamily: 'var(--font-serif)',
          fontSize: '1.75rem',
          fontWeight: 700,
          letterSpacing: '-0.4px',
          lineHeight: 1,
        }}>
          <span style={{ color: TEXT1 }}>Tru</span>
          <span style={{ color: BLUE }}>Flow</span>
        </p>

        <h1 style={{
          margin: '0 0 12px',
          fontFamily: 'var(--font-serif)',
          fontSize: 24,
          fontWeight: 700,
          color: TEXT1,
          lineHeight: 1.25,
        }}>
          Welcome to TruFlow{firstName ? `, ${firstName}` : ''}
        </h1>

        <p style={{
          margin: '0 0 36px',
          fontSize: 15,
          color: TEXT2,
          lineHeight: 1.6,
        }}>
          Let's get you set up in about 3 minutes. We'll calculate your tax reserve,
          map your income pattern, and show you what the next 90 days look like.
        </p>

        <button
          onClick={() => navigate('/onboarding/tax')}
          style={{
            width: '100%',
            backgroundColor: BLUE,
            color: 'var(--on-signal)',
            border: 'none',
            borderRadius: 10,
            padding: 14,
            fontSize: 15,
            fontWeight: 600,
            cursor: 'pointer',
            marginBottom: 24,
          }}
        >
          Get started
        </button>

        <p style={{
          margin: 0,
          fontSize: 12,
          color: TEXT3,
          textAlign: 'center',
        }}>
          Step 1 of 4 · Tax setup is next
        </p>
      </div>
    </div>
  );
}
